import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { Sector } from "../../types/modules/sector.type";

export const useSectors = () => {
  return useQuery({
    queryKey: ["sectors"],
    queryFn: () => fetcher<Sector[]>(`sector`),
  });
};
